import { Box, Grid, Theme, useMediaQuery } from '@mui/material';
import _ from 'lodash';
import { SearchFiltersSkeleton } from '../search-filters/SearchFiltersSkeleton';

interface PaginatedListSkeletonProps {
  ItemSkeleton: React.ReactElement;
}
export const PaginatedListSkeleton: React.FC<PaginatedListSkeletonProps> = ({ ItemSkeleton }) => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const isLargeDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('xl'));
  const skeletonCount = isLargeDesktop ? 4 : isDesktop ? 3 : 2;
  return (
    <Box sx={{ py: 5 }} className="container-fluid">
      <Grid container spacing={2.5}>
        {_.times(skeletonCount, _.stubArray).map((_item, index) => (
          <Grid key={index} item xs={12} sm={6} lg={4} xl={3}>
            {ItemSkeleton}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

interface PaginatedListPageSkeletonProps extends PaginatedListSkeletonProps {
  disableFilters?: boolean;
  disableSearch?: boolean;
  isTitleVisible?: boolean;
  AfterSearchFilterComponent?: React.ReactElement;
}
export const PaginatedListPageSkeleton: React.FC<PaginatedListPageSkeletonProps> = ({
  disableFilters,
  disableSearch,
  ItemSkeleton,
  AfterSearchFilterComponent,
  isTitleVisible = true,
}) => {
  return (
    <div>
      <SearchFiltersSkeleton
        isTitleVisible={isTitleVisible}
        disableFilters={disableFilters}
        disableSearch={disableSearch}
      />
      {AfterSearchFilterComponent}
      <PaginatedListSkeleton ItemSkeleton={ItemSkeleton} />
    </div>
  );
};
